import React from "react";
import PropTypes from "prop-types";

class AlphaPagination extends React.Component {
    static propTypes = {
        data: PropTypes.object
    };

    static defaultProps = {
        data: {}
    };

    navToLetter = (letter) => {
        const endpoint = this.props.data.endpoint ? this.props.data.endpoint : "";

        let qsElement = "?";

        if (/\?/g.test(endpoint)) {
            qsElement = "&";
        }

        if(letter == "#") {
            letter = "num";
        }

        window.location = `${endpoint}${qsElement}letter=${letter}`;
    }

    render() {
        let letter = this.props.data.letter;

        let latters = [..."#ABCDEFGHIJKLMNOPQRSTUVWXYZ"];

        return (
            <div className="AlphaPaginationContainer">
                {latters.map((pageLetter, index) => {
                    return(<button key={index} className={(pageLetter === letter || (pageLetter === "#" && letter === "num")) ? "selected": ""}  onClick={()=>{
                        this.navToLetter(pageLetter);
                    }}>{pageLetter}</button>);
                })}
            </div>
        );
    }
}

export default AlphaPagination;
